import styles from '../StepLayout.module.css';
import { StepLayout } from '../StepLayout';
import { AnimatedWordExample } from '../AnimatedWordExample';
import { TUTORIAL_LETTERS } from '../constants';
import { ru } from '@/i18n/ru';

export function Step3Scoring() {
  return (
    <StepLayout title={ru.onboarding.step3.title}>
      <p>{ru.onboarding.step3.body}</p>
      <div className={styles.formula}>{ru.onboarding.step3.formula}</div>
      <p>{ru.onboarding.step3.legend}</p>
      <div className={styles.examples}>
        <AnimatedWordExample word="компот" letters={TUTORIAL_LETTERS} />
        <AnimatedWordExample word="скотч" letters={TUTORIAL_LETTERS} />
      </div>
      <p>{ru.onboarding.step3.caption}</p>
    </StepLayout>
  );
}
